import LocationForm from '../../../../LocationEditForm/Location';

export default LocationForm;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/edit/Location/Location.js
// module id = 270
// module chunks = 0